// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorControlMessage, ElevatorControlMessageT } from './elevator-control-message';
import { EscalatorControlMessage, EscalatorControlMessageT } from './escalator-control-message';


export enum DeviceControlMessage {
  NONE = 0,
  ElevatorControlMessage = 1,
  EscalatorControlMessage = 2
}

export function unionToDeviceControlMessage(
  type: DeviceControlMessage,
  accessor: (obj:ElevatorControlMessage|EscalatorControlMessage) => ElevatorControlMessage|EscalatorControlMessage|null
): ElevatorControlMessage|EscalatorControlMessage|null {
  switch(DeviceControlMessage[type]) {
    case 'NONE': return null; 
    case 'ElevatorControlMessage': return accessor(new ElevatorControlMessage())! as ElevatorControlMessage;
    case 'EscalatorControlMessage': return accessor(new EscalatorControlMessage())! as EscalatorControlMessage;
    default: return null;
  }
}

export function unionListToDeviceControlMessage(
  type: DeviceControlMessage, 
  accessor: (index: number, obj:ElevatorControlMessage|EscalatorControlMessage) => ElevatorControlMessage|EscalatorControlMessage|null, 
  index: number
): ElevatorControlMessage|EscalatorControlMessage|null {
  switch(DeviceControlMessage[type]) {
    case 'NONE': return null; 
    case 'ElevatorControlMessage': return accessor(index, new ElevatorControlMessage())! as ElevatorControlMessage;
    case 'EscalatorControlMessage': return accessor(index, new EscalatorControlMessage())! as EscalatorControlMessage;
    default: return null;
  }
}

export type DeviceControlMessageT =
  | { type: 'NONE'; value: null }
  | { type: 'ElevatorControlMessage'; value: ElevatorControlMessageT }
  | { type: 'EscalatorControlMessage'; value: EscalatorControlMessageT };
